import {
  FieldPlayerPosition,
  FieldBBSBHandedness,
  FieldHandedness,
} from '@helpers/FormFields';
import { Box } from 'grommet';
import { BASEBALL, SOFTBALL, VOLLEYBALL } from '@constants/strings';
import { ClaimedPlayer } from '@features/Home/claimedPlayer';

const PlayerPositions: React.FC<{
  playerSports: Set<string>;
  updateValues: (val: Partial<ClaimedPlayer>) => void;
  positions: ClaimedPlayer['positions'];
}> = ({ playerSports, positions, updateValues = () => {} }) => {
  const handlePoistionChange = (
    val: Record<string, { primary?: string; secondary?: string }>
  ) => {
    const updatedPositions = { ...positions };
    Object.keys(val).forEach((key) => {
      updatedPositions[key] = {
        ...updatedPositions[key],
        ...val[key],
      };
    });
    updateValues({ positions: updatedPositions });
  };

  const sports = Array.from(playerSports);
  return sports.map((sport: string | undefined, index: number) => (
    <Box key={`sport-${index}`} margin={{ bottom: 'small' }}>
      <FieldPlayerPosition
        isPrimary
        sportType={sport}
        positions={positions}
        handleChange={handlePoistionChange}
      />
      <FieldPlayerPosition
        isPrimary={false}
        sportType={sport}
        positions={positions}
        handleChange={handlePoistionChange}
      />
      {(sport === BASEBALL.display || sport === SOFTBALL.display) && (
        <>
          <FieldBBSBHandedness isBatting />
          <FieldBBSBHandedness isBatting={false} />
        </>
      )}
      {sport === VOLLEYBALL.display && <FieldHandedness />}
    </Box>
  ));
};

export default PlayerPositions;
